import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import { IClassService } from '../../Services/class-service';
import { IServiceFactory } from '../../Services/service-factory';
import { ELearningDashboardClass } from '../../Elearning-Models';


export interface ClassData{
  classes: ELearningDashboardClass[];
}

@Component({
  selector: 'app-elearningdash-classmgmt-dialog',
  templateUrl: './elearningdash-classmgmt-dialog.component.html',
  styleUrls: ['./elearningdash-classmgmt-dialog.component.scss']
})
export class ElearningdashClassmgmtDialogComponent implements OnInit {

selectedValues : ELearningDashboardClass[] = [];
classes: ELearningDashboardClass[] = [];

@Input() serviceFactory: IServiceFactory;
  classService: IClassService;

  constructor(
    public dialogRef: MatDialogRef<ElearningdashClassmgmtDialogComponent>
    ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.classService = this.serviceFactory.getClassService();
    this.classService.classesAvailableEmitter.subscribe(result => {
      this.onClassesAvailable(result);
    })
    this.classService.GetOrSetClasses();
  }

  onClassesAvailable(result: ELearningDashboardClass[]) {
    this.classes = result;
  }

  updateClassFilter($event, dashboardClass: ELearningDashboardClass){
    var b = $event.currentTarget.checked;
    this.classService.UpdateDashboardVisibility(dashboardClass, !b);
  }
}


  
